import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
  const { user, logout } = useAuth();
  const [hasPaid, setHasPaid] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/payments/check-payment-status?userEmail=${encodeURIComponent(user?.email || '')}`);
        const data = await response.json();
        setHasPaid(Boolean(data.hasPaid));
      } catch (error) {
        console.error('Error checking payment status:', error);
        setHasPaid(false);
      } finally {
        setLoading(false);
      }
    };

    if (user?.email) {
      checkPaymentStatus();
    }
  }, [user]);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#080808',
      color: '#ffffff',
      fontFamily: "'Instrument Sans', sans-serif",
      padding: '120px 20px 40px'
    }}>
      <nav style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '20px 40px',
        background: 'rgba(8,8,8,.94)',
        borderBottom: '1px solid rgba(250,204,21,.25)',
        backdropFilter: 'blur(18px)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <img
            src="/logo.svg"
            alt="KPL Ventures Logo"
            style={{
              width: 56,
              height: 56,
              objectFit: 'contain',
              display: 'block',
              filter: 'brightness(0) saturate(100%) invert(82%) sepia(42%) saturate(1198%) hue-rotate(352deg) brightness(102%) contrast(96%) drop-shadow(0 0 8px rgba(250,204,21,.25))'
            }}
          />
          <span style={{
            fontSize: 12,
            letterSpacing: '.2em',
            color: '#facc15',
            fontWeight: 500,
            whiteSpace: 'nowrap'
          }}>
            KPL VENTURES
          </span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              fontSize: 13,
              fontWeight: 600,
              padding: '8px 16px',
              background: 'transparent',
              color: '#9ca3af',
              border: '1px solid rgba(250,204,21,.25)',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            HOME
          </button>
          <button
            onClick={logout}
            style={{
              fontSize: 13,
              fontWeight: 600,
              padding: '8px 16px',
              background: '#facc15',
              color: '#080808',
              border: 'none',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            LOGOUT
          </button>
        </div>
      </nav>

      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{
          color: '#facc15',
          fontSize: '32px',
          fontWeight: '700',
          marginBottom: '20px'
        }}>
          Welcome to KPL Ventures
        </h1>

        <div style={{
          background: 'rgba(255,255,255,.02)',
          border: '1px solid rgba(250,204,21,.2)',
          borderRadius: '8px',
          padding: '30px',
          marginBottom: '30px'
        }}>
          <h2 style={{
            color: '#facc15',
            fontSize: '24px',
            marginBottom: '15px'
          }}>
            Your Account
          </h2>
          <p style={{ color: '#9ca3af', marginBottom: '10px' }}>
            <strong>Name:</strong> {user?.displayName || 'N/A'}
          </p>
          <p style={{ color: '#9ca3af', marginBottom: '10px' }}>
            <strong>Email:</strong> {user?.email}
          </p>
          <p style={{ color: '#9ca3af' }}>
            <strong>UID:</strong> {user?.uid}
          </p>
        </div>

        <div style={{
          background: 'rgba(255,255,255,.02)',
          border: '1px solid rgba(250,204,21,.2)',
          borderRadius: '8px',
          padding: '30px',
          marginBottom: '30px'
        }}>
          <h2 style={{
            color: '#facc15',
            fontSize: '24px',
            marginBottom: '15px'
          }}>
            Program Access
          </h2>
          <p style={{ color: '#9ca3af', marginBottom: '20px' }}>
            As a registered user, you now have access to apply for the KPL Ventures program and make payments.
          </p>

          {loading ? (
            <p style={{ color: '#9ca3af' }}>Checking payment status...</p>
          ) : hasPaid ? (
            <div style={{
              background: 'rgba(34, 197, 94, 0.1)',
              border: '1px solid #22c55e',
              borderRadius: '4px',
              padding: '15px',
              marginBottom: '20px'
            }}>
              <p style={{ color: '#22c55e', fontWeight: '600', margin: 0 }}>
                  ✅ Payment Completed - <a href="/welcome" style={{ color: '#22c55e', textDecoration: 'underline' }}>Go to Welcome Page</a>
              </p>
            </div>
          ) : (
            <>
              <button
                onClick={() => window.location.href = '/'}
                style={{
                  background: '#facc15',
                  color: '#080808',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '4px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  marginRight: '15px'
                }}
              >
                Apply Now
              </button>
              <button
                onClick={() => window.location.href = '/payment'}
                style={{
                  background: 'transparent',
                  color: '#facc15',
                  border: '1px solid #facc15',
                  padding: '12px 24px',
                  borderRadius: '4px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                Make Payment
              </button>
            </>
          )}
        </div>

        <button
          onClick={logout}
          style={{
            background: 'rgba(239, 68, 68, 0.1)',
            color: '#ef4444',
            border: '1px solid #ef4444',
            padding: '12px 24px',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default Dashboard;